export const MONTHS = [
  "Apr", "May", "Jun", "Jul", "Aug", "Sep",
  "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",
];

const deviationConfig = {
  modules: ["Energy", "Water", "Waste", "Emission"],
};

export default deviationConfig;
